import { PREVIOUS_INSURANCE_MISS_MATCH_TYPE } from '@/features/PreviousInsurance/Components/ContractDatesMissMatchInfo/types';
import {
  isAenderungsAntragWithContractTariff,
  isCarChange,
  isErstvertragOhneVorversicherung,
  isWiederinbetriebnahme,
  isZweitwagen,
} from '@/features/Sparten/shared/renderConditions/kfz/sharedRenderConditions';

export const relevantPreviousInsuranceMissMatchTypes = () => {
  if (isZweitwagen.value || isErstvertragOhneVorversicherung.value) {
    return [];
  }

  if (isCarChange.value || isWiederinbetriebnahme.value) {
    return [PREVIOUS_INSURANCE_MISS_MATCH_TYPE.OVERLAP];
  }

  if (isAenderungsAntragWithContractTariff.value) {
    return [PREVIOUS_INSURANCE_MISS_MATCH_TYPE.GAP];
  }

  return [
    PREVIOUS_INSURANCE_MISS_MATCH_TYPE.GAP,
    PREVIOUS_INSURANCE_MISS_MATCH_TYPE.OVERLAP,
  ];
};
